import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import { Link } from 'react-router';
import { push } from 'redux-router';

import Select from '../../components/form/select/select';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import Image from '../../components/image/image';
import placeholderImage from './top-placeholder.png';
import placeholderLogo from './logo-placeholder.png';
import css from './profile.scss';
import Pixeltext from '../../components/svg/pixeltext';
import { formatNumber, DateFormatter } from '../../utils/date';
import { casesRoute } from '../../routes/index';
import forEach from 'lodash/forEach';

import RelatedCases from '../../components/relatedcases/relatedcases';
import RelatedInterviews from '../../components/relatedinterviews/relatedinterviews';
import RelatedJobs from '../../components/relatedjobs/relatedjobs';
import ContextualMenu from '../../components/contextual/contextual';
import { Player, PlayerButtonTrigger} from '../../components/video/player';

import metaDesc from '../../utils/meta';

import Share from '../../components/share/share';

import graphTextDots from './graph-text-dots.png';

import Tooltip from '../../components/tooltip/tooltip';
import translate from '../../utils/translate';

import connect from '../../utils/connect';

import { fetchSingleProfile, flushProfile, fetchProfileCases } from '../../actions/profiles';

import logo from './fwa-logo.png';

//import css from './editorial.scss';

class ProfilePage extends Component {

	constructor(props) {
		super();

		this.nextInterval = 0;
		this.prevInterval = 0;

		this.state = {
			loading: true,
			activeOffice: 0,
			cases: false,
			extraHistoryHeight: 0,
		};

		this.metaDesc = '';
		this.extraHistoryHeight = 0;
	}

	componentWillMount() {
		this.fetchSingle = bindActionCreators(fetchSingleProfile, this.props.dispatch);
		this.fetchCases = bindActionCreators(fetchProfileCases, this.props.dispatch);
		this.flushProfile = bindActionCreators(flushProfile, this.props.dispatch);

		if (
			this.props.routeParams.slug &&
			this.props.routeParams.slug !== this.props.profiles.single.slug
		) {
			if (!this.state.loading) {
				this.setState({
					loading: true,
				});
			}

			this.fetchSingle(this.props.routeParams.slug);
		}
	}

	componentWillReceiveProps(nextProps) {
		const newState = {};
		if (nextProps.routeParams.slug !== this.props.routeParams.slug) {
			newState.loading = true;

			this.fetchSingle(nextProps.routeParams.slug);
		}

		if (nextProps.profiles.cases && nextProps.profiles.cases.cases) {
			newState.cases = nextProps.profiles.cases.cases;
		}

		if (
			this.state.loading &&
			nextProps.routeParams.slug === nextProps.profiles.single.slug &&
			(nextProps.profiles.single && !nextProps.profiles.single.hero)
		) {
			this.setState({
				loading: false,
			});
		}

		(Object.keys(newState).length) && this.setState(newState);
	}

	shouldComponentUpdate(nextProps, nextState) {
		return (
			nextProps.browser.window.width !== this.props.browser.window.width ||
			nextProps.profiles.single.id !== this.props.profiles.single.id ||
			nextProps.profiles.single.name !== this.props.profiles.single.name ||
			nextProps.profiles.cases !== this.props.profiles.cases ||
			nextState !== this.state
		);
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.profiles.single.relatedCasesCount > 0 && this.props.profiles.single.id !== prevProps.profiles.single.id) {
			this.fetchCases(this.props.routeParams.slug);
		}

		if (this.state.cases && this.state.cases.length) {
			this.extraHistoryHeight = 0;
			if (this.refs.awardHistory) {
				this.refs.awardHistory.scrollLeft = 100000;
			}
		}
	}

	componentWillUnmount() {
		this.flushProfile();
	}

	render() {
		let profile = this.props.profiles.single;
		let { browser } = this.props;

		let transitionClass = 'page__transition';

		if (this.state.loading) {
			transitionClass += ' page__transition--transitioning';
		}

		if (this.props.profiles.cases && this.props.profiles.cases.cases) {
			profile.cases = this.props.profiles.cases.cases;
		}

		let loadingRelated = false;

		if (profile.relatedCasesCount > 0 && !profile.cases) {
			loadingRelated = true;
		}

		if (profile.meta && profile.meta.description !== this.metaDesc) {
			metaDesc(profile.meta.description);
			this.metaDesc = profile.meta.description;
		}

		return (
			<div>
			{profile.name && (
				<article className='profile margin-bottom-contextual'>
					<Helmet title={profile.name + ' - The FWA'} />

					<div className={transitionClass}>
						<Image className='profile__hero-image span14' img={profile.hero} span='span14' browser={browser} onLoad={() => this.onImageLoaded()} />

						<section className='profile__info span14'>
							<h3 className='profile__info__type'>Profile</h3>
							<h1 className='profile__info__title'>{profile.name}</h1>
							<div className='profile__info__btns hide-mobile'>
								{profile.showreel && (
									<PlayerButtonTrigger browser={browser} className='profile__info__btns__btn' text={'Agency Reel'} url={profile.showreel} />
								)}
								{profile.website && (
									<a className='button button--dark button--go' href={profile.website} target='_blank'>Agency website</a>
								)}
							</div>
						</section>
						{(profile.showreel || profile.website) && (
							<div className='profile__info__btns span14-mobile hide-desktop hide-tablet'>
								{profile.showreel && (
									<PlayerButtonTrigger browser={browser} className='profile__info__btns__btn' text={'Agency Reel'} url={profile.showreel} />
								)}
								{profile.website && (
									<a className='button button--dark button--go' href={profile.website} target='_blank'>Agency website</a>
								)}
							</div>
						)}

						{(!!profile.stats.count) && (
							this.renderStats(profile.stats)
						)}

						{profile.isHof === 1 && profile.isHundred === 1 && (
							<div className='span6 span9-tablet span14-mobile profile__hof-hundred'>
								<div className='profile__hof profile__hof--hundred profile__hof--one-of'><img className='profile__hof__img profile__hof__img--one-of' src={logo.src} role='presentation' />Member <span className='profile__hof__weak'>FWA Club 100</span></div>
								<div className='profile__hof profile__hof--one-of'><img className='profile__hof__img profile__hof__img--one-of' src={logo.src} role='presentation' />Member <span className='profile__hof__weak'>FWA Hall of fame</span></div>
							</div>
						) || profile.isHof === 1 && (
							<div className='profile__hof span5 span7-tablet span14-mobile'>
								<img className='profile__hof__img' src={logo.src} role='presentation' />Member <span className='profile__hof__weak'>FWA Hall of fame</span><span className='profile__hof__since'>Since {profile.hofSince.split('-')[0]}</span>
							</div>
						) || profile.isHundred === 1 && (
							<div className='profile__hof profile__hof--hundred span5'><img className='profile__hof__img' src={logo.src} role='presentation' />Member <span className='profile__hof__weak'>FWA Club 100</span></div>
						) || (
							<div className='profile__spacer span5 pixel-pattern hide-mobile'></div>
						)}

						{profile.intro && (
							<section className='profile__description span14'>
								<div className='profile__description__share'>
									<Share title={profile.name} url={window.location.href} browser={browser} />
								</div>
								<h3 className='profile__description__title'>Description:</h3>
								<p className='profile__description__text span9 span10-tablet span12-mobile'>{profile.intro}</p>
							</section>
						)}

						{profile.additional && (
							<section className='profile__extra span14'>
								<div className='profile__extra__left span5 hide-tablet hide-mobile'></div>
								<p className='profile__extra__content span8 span13-tablet span12-mobile'>{profile.additional}</p>
							</section>
						)}

						<section className='profile__meta hide-mobile' id='contact'>
							<div className='cf'></div>
							<div className='profile__meta__left span5 span7-tablet span14-mobile'>
								{(profile.logoProfile && profile.logoProfile.normal) && (
									<img className='profile__meta__image' {...profile.logoProfile.normal} alt={profile.name} />
								)}
							</div>
							<div className='profile__meta__offices span9 span7-tablet span14-mobile'>
								{(profile.instagram || profile.linkedin || profile.twitter || profile.facebook) && (
									<div className='profile__meta__social-wrap hide-tablet hide-mobile'>
										{profile.facebook && (
											<a className='button profile__meta__social' href={profile.facebook}>Facebook</a>
										)}
										{profile.twitter && (
											<a className='button profile__meta__social' href={profile.twitter}>Twitter</a>
										)}
										{profile.linkedin && (
											<a className='button profile__meta__social' href={profile.linkedin}>LinkedIn</a>
										)}
										{profile.instagram && (
											<a className='button profile__meta__social' href={profile.instagram}>Instagram</a>
										)}
									</div>
								)}
								{profile.offices && profile.offices.length && (
									this.renderOffices(profile.offices, profile)
								)}
							</div>
						</section>
						{(profile.instagram || profile.linkedin || profile.twitter || profile.facebook) && (
							<div className='profile__meta__social-wrap hide-desktop'>
								{profile.facebook && (
									<a className='button profile__meta__social' href={profile.facebook}>Facebook</a>
								)}
								{profile.twitter && (
									<a className='button profile__meta__social' href={profile.twitter}>Twitter</a>
								)}
								{profile.linkedin && (
									<a className='button profile__meta__social' href={profile.linkedin}>LinkedIn</a>
								)}
								{profile.instagram && (
									<a className='button profile__meta__social' href={profile.instagram}>Instagram</a>
								)}
							</div>
						)}

						{loadingRelated && browser.window.width > 719 && (
							<section className='profile__award-history__wrapper span14'>
								{profile.name.slice(-1) != 's' && (
								<h2 className='profile__award-history__title'>{profile.name + '\'s FWA History '}</h2>
								) || (
								<h2 className='profile__award-history__title'>{profile.name + '\' FWA History '}</h2>
								)}
								<h3 className='profile__award-history__sub-title'>timeline:</h3>
								<Spinner size='40px' className='profile__loading' />
							</section>
						)}

						{profile.cases && profile.cases.length && browser.window.width > 719 && (
							<section className='profile__award-history__wrapper span14'>
								{profile.name.slice(-1) != 's' && (
									<h2 className='profile__award-history__title'>{profile.name + '\'s FWA History '}</h2>
								) || (
									<h2 className='profile__award-history__title'>{profile.name + '\' FWA History '}</h2>
								)}

								<h3 className='profile__award-history__sub-title'>timeline:</h3>
								<a
									href='#'
									className='profile__award-history__prev'
									onClick={(event) => this.awardPrevent(event)}
									onMouseDown={(event) => this.awardHoldPrev(event)}
									onTouchStart={(event) => this.awardHoldPrev(event)}
									onMouseUp={(event) => this.awardReleasePrev(event)}
									onTouchEnd={(event) => this.awardReleasePrev(event)}
									onDragOver={() => this.awardDrag()}
								></a>

								<section className='profile__award-history span14' ref='awardHistory'>
									{this.renderAwardHistory(profile.cases)}
								</section>

								<a
									href='#'
									className='profile__award-history__next'
									onClick={(event) => this.awardPrevent(event)}
									onMouseDown={(event) => this.awardHoldNext(event)}
									onTouchStart={(event) => this.awardHoldNext(event)}
									onMouseUp={(event) => this.awardReleaseNext(event)}
									onTouchEnd={(event) => this.awardReleaseNext(event)}
									onDragOver={() => this.awardDrag()}
								></a>
							</section>
						) || null}
						{profile.editorials && !!profile.editorials.length && (
							<div className='profile__spacer span5 pixel-pattern'></div>
						) || null}
						{profile.editorials && !!profile.editorials.length && (
							<RelatedInterviews interviews={profile.editorials} browser={browser} title={'Editorials by ' + profile.name} />
						) || null}
						<div className='profile__spacer span5 pixel-pattern'></div>
						<RelatedJobs jobs={profile.jobs} title={'Jobs at ' + profile.name} browser={browser} />
						{profile.cases && !!profile.cases.length && (
							<div className='profile__spacer span5 pixel-pattern'></div>
						)}
						{loadingRelated && (
							<Spinner size='40px' className='profile__loading profile__loading--relative' />
						)}
						{profile.cases && !!profile.cases.length && (
							<RelatedCases profile={true} parentSlug={profile.slug} typeSlug='profiles' cases={profile.cases} names={profile.name} browser={browser} />
						)}

						<div className='cf'></div>
					</div>
					<ContextualMenu enableProfiles={true} nextProfile={profile.next} prevProfile={profile.prev} />
				</article>
			)}
			</div>
		);
	}

	onImageLoaded() {
		if (this.state.loading && this.props.routeParams.slug === this.props.profiles.single.slug) {
			this.setState({
				loading: false,
			});
		}
	}

	renderStats(stats) {
		let extra = [];
		let statsArr = [];
		let count = stats.count;

		forEach(stats.awards, function(award, key) {
			let local = {
				name: key,
				number: award,
			};

			statsArr.push(local);
		});

		if (statsArr.length < 8) {
			for (var i = 0; i < 8 - statsArr.length; i++) {
				extra.push('placeholder');
			};
		}

		if (count < 10) {
			count = '0' + count;
		}

		return (
			<div key='stats' className='profile__stats span14'>
				<div className='profile__stats__left span10'>
					{statsArr.map((stat, i) => this.renderStat(stat, i))}
					{extra.map((...i) => this.renderStat(...i))}
				</div>
				<div className='profile__stats__stat profile__stats__stat--big pixel-pattern span4 span7-mobile'>
					<h3 className='profile__stats__stat__title'>AWARDS:</h3>
					<Pixeltext text={count.toString()} className='profile__stats__stat__number'/>
				</div>
				<div className='cf'></div>
			</div>
		);
	}

	renderStat(stat, i) {
		let uid = 'stat -' + i;
		let number = 0;

		if (stat.number) {
			number = stat.number;

			if (number < 10) {
				number = '0' + number;
			}
		}

		return (
			<div key={uid} className='profile__stats__stat pixel-pattern hide-mobile'>
				{stat.name && (
				<div>
					<h3 className='profile__stats__stat__title' ref={stat.name.toLowerCase()}>{stat.name}:</h3>
					<Tooltip attachTo={() => this.getRef(stat.name.toLowerCase())}>
						<header>description:</header>
						<h2>{translate('awards/' + stat.name.toLowerCase() + '/title')}</h2>
						{translate('awards/' + stat.name.toLowerCase() + '/text')}
					</Tooltip>
					<Pixeltext text={number.toString()} className='profile__stats__stat__number'/>
				</div>
				) || null}
			</div>
		);
	}

	renderOffices(offices, profile) {

		let options = [];

		offices.map((office, i) => {
			//Add +1 to value, to not have value: 0 in <select>
			options.push({
				label: office.name,
				value: i + 1,
			});
		});

		return (
			<div>
				{offices.length > 1 && (
				<Select
					onChange={(event) => this.officeChange(event)}
					ref='officeInput'
					className='span2 span3-tablet span12-mobile'
					placeholder='Other offices'
					options={options} />
				)}

				<ul className='profile__meta__offices__office-holder'>
					{offices.map((office, i) => this.renderOffice(office, i, profile))}
				</ul>
			</div>
		);
	}

	officeChange(e) {
		//We need to substract one, as we added on above. All due to value:0 being regarded as nothing in a select.

		this.setState({
			activeOffice: this.refs.officeInput.value - 1,
		});
	}

	renderOffice(office, i, profile) {
		let uid = 'office-' + i;
		let className = 'profile__meta__offices__office';
		if (this.state.activeOffice == i) {
			className += ' profile__meta__offices__office--active';
		}

		let email = profile.contactEmail;

		if (office.email && office.email !== '') {
			email = office.email;
		}

		return(
			<li key={uid} ref={uid} className={className}>
				<div className='profile__meta__offices__office__location span2 span3-tablet span8-mobile'>
					<h2 className='profile__meta__offices__office__name'>{`${profile.name} ${office.name}`}</h2>
					<span>{office.address1}</span>
					<span>{office.address2}</span>
					<span>{office.address3}</span>
					<span>{office.country}</span>
				</div>
				<div className='profile__meta__offices__office__contact span2 span3-tablet span8-mobile'>
					<span>{office.phone}</span>
					<span><a href={`mailto:${profile.contactEmail}`}>{email}</a></span>
					<span><a href={profile.website}>{profile.website}</a></span>
				</div>
			</li>
		);
	}

	awardPrevent(e) {
		e.preventDefault();
	}

	awardHoldNext(e) {
		var _this = this;
		clearInterval(this.prevInterval);
		clearInterval(this.nextInterval);

		this.nextInterval = setInterval(function() {
			_this.refs.awardHistory.scrollLeft += 5;
		}, 10);
	}

	awardReleaseNext(e) {
		clearInterval(this.prevInterval);
		clearInterval(this.nextInterval);
	}

	awardHoldPrev(e) {
		var _this = this;
		clearInterval(this.nextInterval);
		clearInterval(this.prevInterval);

		this.prevInterval = setInterval(function() {
			_this.refs.awardHistory.scrollLeft -= 5;
		}, 10);
	}

	awardReleasePrev(e) {
		clearInterval(this.prevInterval);
		clearInterval(this.nextInterval);
	}

	awardHover(uid) {

		var all = document.querySelectorAll('.profile__award-history__award');

		for (var i = 0; i < all.length; i++) {
			all[i].classList.add('inactive');
		}

		this.refs[uid].classList.remove('inactive');

	}

	awardHoverOut() {

		var all = document.querySelectorAll('.profile__award-history__award');

		for (var i = 0; i < all.length; i++) {
			all[i].classList.remove('inactive');
		}
	}

	awardDrag() {
		//People accidently dragged the button :(

		clearInterval(this.prevInterval);
		clearInterval(this.nextInterval);
	}

	renderAwardHistory(awards) {

		let years = [];

		this.yearNum = -1;

		this.yearsCount = 0;

		let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

		awards.map((award, i) => {
			award.awards.map((aw) => {
				let awardYear = aw.awardedDate;
				let dontAdd = false;
				awardYear = awardYear.split('-');
				awardYear = awardYear[0];
				if (years[awardYear]) {
					years[awardYear].map((idTest) => {
						if (idTest.id == award.id) {
							dontAdd = true;
						}
					});
					if (!dontAdd) {
						let localAward = years[awardYear];
						localAward.push(award);
						years[awardYear] = localAward;
					}
				} else {
					years[awardYear] = new Array(award);
					this.yearsCount += 1;
				}
			});
		});

		years.map((test, i) => {
			months.map((month) => {
				let localNum = 0;
				test.map((awards) => {
					awards.awards.map((tests) => {
						if (tests.awardedDate.split('-')[1] == month && tests.awardedDate.split('-')[0] == i) {
							localNum++;
						}
					});
				});
				if (localNum > 7) {
					let localHeight = localNum * 20 + 20 + 38;
					if (localHeight > this.extraHistoryHeight) {
						this.extraHistoryHeight = localHeight;
					}
				}
			});
		});

		let extraW = 98;

		if (this.props.browser.window.width < 1200) {
			extraW = 50;
		}

		if (this.props.browser.window.width < 720) {
			extraW = 0;
		}

		if (this.yearsCount == 1) {
			extraW = 520;

			if (this.props.browser.window.width < 1000) {
				extraW = 0;
			}
		}

		let yearStyle = {};
		let historyStyle = {width: this.yearsCount * 650 + extraW + 'px'};

		if (this.extraHistoryHeight != 0) {
			yearStyle = {height: this.extraHistoryHeight + 'px'};
			historyStyle = {...historyStyle, ...yearStyle}
		}

		return (
			<svg key='awardHistory' className='pixel-pattern profile__award-history__holder' scrollLeft='300px' style={historyStyle}>
				<pattern id='lineDots' patternUnits='userSpaceOnUse' width={1} height={2}>
					<image width={graphTextDots.width} height={graphTextDots.height} xlinkHref={graphTextDots.src}></image>
				</pattern>
				{years.map((year, key) => this.renderYear(year, key))}
			</svg>
		);
	}

	renderYear(awards, year, yearStyle) {
		let uid = 'award-' + year;

		let months = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];

		this.yearNum += 1;

		let yearWidth = 650;

		if (this.yearsCount == 1 && this.props.browser.window.width > 1000) {
			yearWidth = 1170;
		}

		return (
			<svg key={uid} x={this.yearNum * yearWidth} style={yearStyle} className='profile__award-history__year' >
				{this.extraHistoryHeight != 0 && (
				<text x='30' y={this.extraHistoryHeight - 48} className='profile__award-history__year__text--awards'>{year}</text>
				) || (
				<text x='30' y='130' className='profile__award-history__year__text--awards'>{year}</text>
				)}
				{this.extraHistoryHeight != 0 && (
				<text x='30' y={this.extraHistoryHeight - 28} className='profile__award-history__year__text--year'>awards</text>
				) || (
				<text x='30' y='150' className='profile__award-history__year__text--year'>awards</text>
				)}

				{this.yearNum > 0 && this.extraHistoryHeight != 0 && (
				<line className='profile__award-history__year-line' x1='0' x2='0' y1='0' y2={this.extraHistoryHeight}></line>
				) || this.yearNum > 0 && (
				<line className='profile__award-history__year-line' x1='0' x2='0' y1='0' y2='178'></line>
				)}
				{months.map((month,i) => {
					let uid = 'month-' + i;
					let thisMonth = [];
					let monthNum = i;
					let between = 50;

					if (this.yearsCount == 1 && this.props.browser.window.width > 1000) {
						between = 95;
					}

					let lineDistance = between / 4 - 1;
					let bottomDistance = between / 4;

					let monthX = 50 + i * between;

					awards.map((award, i) => {
						award.awards.map((aw, i) => {

							if (aw.awardedDate.split('-')[1] == month && aw.awardedDate.split('-')[0] == year) {
								let localAward = {
									date: aw.awardedDate,
									type: aw.type,
									award: award,
								};
								thisMonth.push(localAward);
							}
						});

						// if (award.createdDate.split('-')[1] == month){
						// 	thisMonth.push(award);
						// }
					});

					if (thisMonth.length > 7) {
						let localHeight = (thisMonth.length - 7) * 20 + 20
						if (this.extraHistoryHeight < localHeight) {
							this.extraHistoryHeight = localHeight;
						}
					}

					return (
						<g key={uid}>
							<line x1={monthX + 6} x2={monthX + 6} y1='0' y2='25' className='profile__award-history__month__line'></line>
							{month == '01' && this.extraHistoryHeight != 0 && (
								<g>
									<line x1={monthX - 6} x2={monthX - 6} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 17} x2={monthX - 17} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 28} x2={monthX - 28} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 39} x2={monthX - 39} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 6} x2={monthX - 6} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight-10} className='profile__award-history__month__line'></line>
									<line x1={monthX - 17} x2={monthX - 17} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight-10} className='profile__award-history__month__line'></line>
									<line x1={monthX - 28} x2={monthX - 28} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight-10} className='profile__award-history__month__line'></line>
									<line x1={monthX - 39} x2={monthX - 39} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight-10} className='profile__award-history__month__line'></line>
								</g>
							) || month == '01' && (
								<g>
									<line x1={monthX - 6} x2={monthX - 6} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 17} x2={monthX - 17} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 28} x2={monthX - 28} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 39} x2={monthX - 39} y1='0' y2='10' className='profile__award-history__month__line'></line>
									<line x1={monthX - 6} x2={monthX - 6} y1='178' y2='168' className='profile__award-history__month__line'></line>
									<line x1={monthX - 17} x2={monthX - 17} y1='178' y2='168' className='profile__award-history__month__line'></line>
									<line x1={monthX - 28} x2={monthX - 28} y1='178' y2='168' className='profile__award-history__month__line'></line>
									<line x1={monthX - 39} x2={monthX - 39} y1='178' y2='168' className='profile__award-history__month__line'></line>
								</g>
							)}
							<line x1={monthX + lineDistance * 1} x2={monthX + lineDistance * 1} y1='0' y2='10' className='profile__award-history__month__line'></line>
							<line x1={monthX + lineDistance * 2} x2={monthX + lineDistance * 2} y1='0' y2='10' className='profile__award-history__month__line'></line>
							<line x1={monthX + lineDistance * 3} x2={monthX + lineDistance * 3} y1='0' y2='10' className='profile__award-history__month__line'></line>
							<line x1={monthX + lineDistance * 4} x2={monthX + lineDistance * 4} y1='0' y2='10' className='profile__award-history__month__line'></line>

							{this.extraHistoryHeight != 0 && (
							<g>
								<line x1={monthX + bottomDistance * 1} x2={monthX + bottomDistance * 1} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight - 10} className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 2} x2={monthX + bottomDistance * 2} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight - 10} className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 3} x2={monthX + bottomDistance * 3} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight - 10} className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 4} x2={monthX + bottomDistance * 4} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight - 10} className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 5} x2={monthX + bottomDistance * 5} y1={this.extraHistoryHeight} y2={this.extraHistoryHeight - 10} className='profile__award-history__month__line'></line>
							</g>
							) || (
							<g>
								<line x1={monthX + bottomDistance * 1} x2={monthX + bottomDistance * 1} y1='178' y2='168' className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 2} x2={monthX + bottomDistance * 2} y1='178' y2='168' className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 3} x2={monthX + bottomDistance * 3} y1='178' y2='168' className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 4} x2={monthX + bottomDistance * 4} y1='178' y2='168' className='profile__award-history__month__line'></line>
								<line x1={monthX + bottomDistance * 5} x2={monthX + bottomDistance * 5} y1='178' y2='168' className='profile__award-history__month__line'></line>
							</g>
							)}
							<g>
								<text className='profile__award-history__award__text profile__award-history__award__text--safari' x='325' y='163'>safari bugfix</text>
							</g>
							{thisMonth.map((award, i) => {
								let uid = 'singleAward-' + this.yearNum + '-' + monthNum + '-' + i;
								let date = new DateFormatter(award.date);
								let awardClass = 'profile__award-history__award__' + award.type.toLowerCase() + ' profile__award-history__award__single';
								let url = '';

								if (award.award.slug && casesRoute(award.award.slug) && !!casesRoute(award.award.slug).length && !!award.award.slug.length) {
									url = casesRoute(award.award.slug);
								}

								//@TODO add real URL again! :) - Figure out why it crashes everything (jam3 -> big spaceship)


								return (
									<g onMouseEnter={() => { this.awardHover(uid); }} onMouseLeave={() => { this.awardHoverOut(); }} key={uid} ref={uid} className='profile__award-history__award'>
										<a xlinkHref={url} onClick={(e) => {
											e.preventDefault();
											this.props.dispatch(push(url));
										}}>
											{award.award.thumbnail[1364] && (
											<g className='profile__award-history__award__image' dangerouslySetInnerHTML={{__html: "<image x=" + (monthX -  68) + " y=" + (30 + i * 20 - 90) + " width='146' height='93' xlink:href=" + award.award.thumbnail[1364].span3 + " />"}} />
											)}

											<rect className='profile__award-history__award__dot' x={monthX + 5} y={30 + i * 20 + 5} width='2' height='2'></rect>
											{this.extraHistoryHeight != 0 && (
												<text className='profile__award-history__award__text' x='325' y={this.extraHistoryHeight - 15}>{award.type + ' ' + date.date + ' ' + date.month.substr(0,3)}</text>
											) || (
											<text className='profile__award-history__award__text' x='325' y='163'>{award.type + ' ' + date.date + ' ' + date.month.substr(0,3)}</text>
											)}
										</a>
										<rect className={awardClass} x={monthX} y={30 + i * 20} width='12' height='12' rx='5' ry='5'></rect>
									</g>
								);
							})}
						</g>
					);
				})}

				{this.yearNum > 0 && (
				<line className='profile__award-history__year-line' x1={this.yearNum * 650} x2={this.yearNum * 650} y1='0' y2='178'></line>
				)}

			</svg>
		);
	}

	getRef(name) {
		return this.refs[name];
	}
}

export default connect(ProfilePage);



/** WEBPACK FOOTER **
 ** ./frontend/containers/profile/profile.js
 **/